/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetStageDefinitionDto } from './GetStageDefinitionDto';
import {
    GetStageDefinitionDtoFromJSON,
    GetStageDefinitionDtoFromJSONTyped,
    GetStageDefinitionDtoToJSON,
} from './GetStageDefinitionDto';

/**
 * 
 * @export
 * @interface GetStepDefinitionDto
 */
export interface GetStepDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof GetStepDefinitionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetStepDefinitionDto
     */
    stepType: GetStepDefinitionDtoStepTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetStepDefinitionDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetStepDefinitionDto
     */
    order: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetStepDefinitionDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetStepDefinitionDto
     */
    deadline: GetStepDefinitionDtoDeadlineEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetStepDefinitionDto
     */
    automatic: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetStepDefinitionDto
     */
    showInChecklist: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetStepDefinitionDto
     */
    priority: GetStepDefinitionDtoPriorityEnum;
    /**
     * 
     * @type {GetStageDefinitionDto}
     * @memberof GetStepDefinitionDto
     */
    stageDefinition: GetStageDefinitionDto;
}


/**
 * @export
 */
export const GetStepDefinitionDtoStepTypeEnum = {
    AtLeastOneProfilePerMonth: 'AtLeastOneProfilePerMonth',
    NoMediaplanForMediaProfileInCurrentMonth: 'NoMediaplanForMediaProfileInCurrentMonth',
    AtLeastOneItemAdded: 'AtLeastOneItemAdded',
    MediaplanApprovedByClient: 'MediaplanApprovedByClient',
    AllItemsWithAmountsEnteredForCurrentMonth: 'AllItemsWithAmountsEnteredForCurrentMonth',
    RequiredCampaignDocumentsAdded: 'RequiredCampaignDocumentsAdded',
    CurrentMonthReadyForInvoicing: 'CurrentMonthReadyForInvoicing',
    SpecialInvoicingRequest: 'SpecialInvoicingRequest',
    ProjectCancelledRequest: 'ProjectCancelledRequest',
    ProjectDateChangeRequest: 'ProjectDateChangeRequest',
    CheckContractsCoverage: 'CheckContractsCoverage',
    ContractsSignedByResponsiblePerson: 'ContractsSignedByResponsiblePerson',
    ContractSent: 'ContractSent',
    OrderCreatedForSpecialistTeam: 'OrderCreatedForSpecialistTeam',
    OrderApprovedBySpecialistTeam: 'OrderApprovedBySpecialistTeam',
    OrderExecutionCreated: 'OrderExecutionCreated',
    OrderExecutionApproved: 'OrderExecutionApproved',
    OrderExecutionPositionsSumValidation: 'OrderExecutionPositionsSumValidation',
    MonthlySettlementReminder: 'MonthlySettlementReminder',
    StatusConfirmedByDocuments: 'StatusConfirmedByDocuments',
    SalesSettlementCompleted: 'SalesSettlementCompleted',
    PendingFvzAssignedToCampaign: 'PendingFVZAssignedToCampaign',
    MissingFvz: 'MissingFVZ',
    PurchaseSettlementCompleted: 'PurchaseSettlementCompleted',
    CampaignsWithBlockingInvoicingErrors: 'CampaignsWithBlockingInvoicingErrors',
    SalesInvoiceSent: 'SalesInvoiceSent',
    MediaplanCorrection: 'MediaplanCorrection'
} as const;
export type GetStepDefinitionDtoStepTypeEnum = typeof GetStepDefinitionDtoStepTypeEnum[keyof typeof GetStepDefinitionDtoStepTypeEnum];

/**
 * @export
 */
export const GetStepDefinitionDtoDeadlineEnum = {
    SinceProjectCreation: 'SinceProjectCreation',
    LastMonthEnd: 'LastMonthEnd',
    FifteenthOfCurrentMonth: 'FifteenthOfCurrentMonth',
    CurrentMonthEnd: 'CurrentMonthEnd',
    FifteenthOfNextMonth: 'FifteenthOfNextMonth',
    NextMonthEnd: 'NextMonthEnd'
} as const;
export type GetStepDefinitionDtoDeadlineEnum = typeof GetStepDefinitionDtoDeadlineEnum[keyof typeof GetStepDefinitionDtoDeadlineEnum];

/**
 * @export
 */
export const GetStepDefinitionDtoPriorityEnum = {
    High: 'High',
    Medium: 'Medium',
    Low: 'Low'
} as const;
export type GetStepDefinitionDtoPriorityEnum = typeof GetStepDefinitionDtoPriorityEnum[keyof typeof GetStepDefinitionDtoPriorityEnum];


/**
 * Check if a given object implements the GetStepDefinitionDto interface.
 */
export function instanceOfGetStepDefinitionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stepType" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "deadline" in value;
    isInstance = isInstance && "automatic" in value;
    isInstance = isInstance && "showInChecklist" in value;
    isInstance = isInstance && "priority" in value;
    isInstance = isInstance && "stageDefinition" in value;

    return isInstance;
}

export function GetStepDefinitionDtoFromJSON(json: any): GetStepDefinitionDto {
    return GetStepDefinitionDtoFromJSONTyped(json, false);
}

export function GetStepDefinitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStepDefinitionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stepType': json['stepType'],
        'name': json['name'],
        'order': json['order'],
        'active': json['active'],
        'deadline': json['deadline'],
        'automatic': json['automatic'],
        'showInChecklist': json['showInChecklist'],
        'priority': json['priority'],
        'stageDefinition': GetStageDefinitionDtoFromJSON(json['stageDefinition']),
    };
}

export function GetStepDefinitionDtoToJSON(value?: GetStepDefinitionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stepType': value.stepType,
        'name': value.name,
        'order': value.order,
        'active': value.active,
        'deadline': value.deadline,
        'automatic': value.automatic,
        'showInChecklist': value.showInChecklist,
        'priority': value.priority,
        'stageDefinition': GetStageDefinitionDtoToJSON(value.stageDefinition),
    };
}

